import { render } from "./ProductBonus.vue?vue&type=template&id=bc5ae702"
import script from "./ProductBonus.vue?vue&type=script&lang=js"
export * from "./ProductBonus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__